<template>
  <!-- <div class="bottom-safe">
    Personal
  </div> -->
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
  // import BlockNotice from '../blocks/notice/index'

  export default {
    // inject: ['reload'],
    components: {
      // BlockNotice
    },
    data () {
      return {
        slug: this.$route.params.slug
      }
    },
    methods: {
    },
    mounted () {
      // this.slug = this.$route.params.slug
    }
  }
</script>

<style lang="css" scoped>
</style>
